import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import FIELD_TYPE from 'Component/Field/Field.config';

import './Packeta.style';
/** @namespace Bodymod/Packeta/Component/Packeta/Component */
export class PacketaComponent extends PureComponent {
    static propTypes = {
        showPacketaPopUp: PropTypes.func.isRequired,
        // eslint-disable-next-line react/forbid-prop-types
        point: PropTypes.object.isRequired
    };

    renderPacketaPoint() {
        const {
            point: {
                name, zip, city, id
            }
        } = this.props;

        if (id) {
            return (
                <div mix={ { block: 'Packeta', elem: 'Description' } }>
                    <p mix={ { block: 'Packeta', elem: 'Title' } }>{ __('Pickup point') }</p>
                    <p>{ `${name}, ${zip}, ${city}, ID: ${id}` }</p>
                </div>
            );
        }

        return null;
    }

    render() {
        const { showPacketaPopUp, point: { name } } = this.props;
        const renderPacketaPoint = this.renderPacketaPoint.bind(this);
        const buttonLabel = name ? __('Change pickup point') : __('Find pickup point');

        return (
            <div block="Packeta" elem="Content">
                { renderPacketaPoint() }
                <button
                  block="Button"
                  type={ FIELD_TYPE.button }
                  mods={ { isHollow: false } }
                  onClick={ showPacketaPopUp }
                  mix={ { block: 'Packeta', elem: 'Button' } }
                >
                        { buttonLabel }
                </button>
            </div>
        );
    }
}

export default PacketaComponent;
